import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
// import 'vant/types/'
import 'ant-design-vue/dist/antd.css';
import Antd from 'ant-design-vue';
import "normalize.css";
import "lib-flexible";
import TapAndHold from 'vue-tap-and-hold'
import VueAwesomeSwiper from "vue-awesome-swiper";
import 'swiper/dist/css/swiper.css'
import VueRipple from 'vue-long-ripple'
import '@vant/touch-emulator';
// import wechat from "vue-wechat";
//
// Vue.use(wechat);
Vue.use(VueRipple);
Vue.use(Antd);
Vue.use(TapAndHold, {
  holdTime: 2000, // default is 1000
  tapTime: 200 // default is 200
});
import plugins from "./plugins";

Vue.use(Vant);
Vue.use(VueAwesomeSwiper);
// import VueSkeletonLoading from 'vue-skeleton-loading';
// Vue.use(VueSkeletonLoading);
Vue.use(plugins);
Vue.config.productionTip = false;
import { Cascader } from 'vant';
Vue.use(Cascader);
import config from "./config";
Vue.prototype.$config = config;

store.dispatch('init').then(() => {
  new Vue({
    data: {
      config: config
    },
    router,
    store,
    render: h => h(App)
  }).$mount('#app');
}).catch(() => {
});
